var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-l-2 w-4 shrink-0",class:_vm.borderTailwind})
}
var staticRenderFns = []

export { render, staticRenderFns }